import styled, { css } from "styled-components";

const ButtonStyles = css`
  height: 48px;
  background-color: #4d5e60;
  border-radius: 25px;
  text-align: center;
  text-transform: uppercase;
  line-height: 48px;
  display: inline-block;
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  border: none;
  padding: 0 26px;
  cursor: pointer;
`;

export const LinkButton = styled.a`
  ${ButtonStyles}
  text-decoration: none;
`;

export const Button = styled.button`
  ${ButtonStyles}
`;
